import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switcher switcher-{{color}}" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "switcher-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      class: "switcher-input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      checked: _ctx.value
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, _ctx.value]
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<span class=\"switcher-indicator\"><span class=\"switcher-yes\"><span class=\"fa fa-check\"></span></span><span class=\"switcher-no\"><span class=\"fa fa-times\"></span></span></span>", 1)),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1)
  ]))
}